import { shadcn } from '@clerk/themes';

// Base path for the artifact — every Clerk URL (sign-in/up routes, logo,
// redirects) must be prefixed with this so routing works under the
// artifact's mount path.
export const basePath = import.meta.env.BASE_URL.replace(/\/$/, '');

// Colors copied from src/index.css :root — keep in sync if the palette
// changes. Clerk's appearance API needs literal CSS color values, it can't
// read the app's CSS custom properties.
export const clerkAppearance = {
  theme: shadcn,
  cssLayerName: 'clerk',
  options: {
    logoPlacement: 'inside' as const,
    logoLinkUrl: basePath || '/',
    logoImageUrl: `${window.location.origin}${basePath}/logo.svg`,
  },
  variables: {
    colorPrimary: 'hsl(15, 60%, 50%)',
    colorForeground: 'hsl(240, 20%, 15%)',
    colorMutedForeground: 'hsl(240, 10%, 45%)',
    colorDanger: 'hsl(0, 70%, 50%)',
    colorBackground: 'hsl(40, 40%, 98%)',
    colorInput: 'hsl(0, 0%, 100%)',
    colorInputForeground: 'hsl(240, 20%, 15%)',
    colorNeutral: 'hsl(40, 20%, 85%)',
    fontFamily: "'Inter', sans-serif",
    borderRadius: '0.5rem',
  },
  elements: {
    rootBox: 'w-full flex justify-center',
    cardBox:
      'bg-[hsl(40,40%,98%)] rounded-2xl w-[440px] max-w-full overflow-hidden border border-[hsl(40,20%,88%)] shadow-lg',
    card: '!shadow-none !border-0 !bg-transparent !rounded-none',
    footer: '!shadow-none !border-0 !bg-transparent !rounded-none',
    headerTitle: 'font-serif text-[hsl(240,20%,15%)]',
    headerSubtitle: 'text-[hsl(240,10%,45%)]',
    socialButtonsBlockButtonText: 'text-[hsl(240,20%,15%)] font-medium',
    formFieldLabel: 'text-[hsl(240,20%,15%)] font-medium',
    footerActionLink: 'text-[hsl(15,60%,50%)] font-medium hover:text-[hsl(15,60%,40%)]',
    footerActionText: 'text-[hsl(240,10%,45%)]',
    dividerText: 'text-[hsl(240,10%,45%)]',
    identityPreviewEditButton: 'text-[hsl(15,60%,50%)]',
    formFieldSuccessText: 'text-[hsl(240,10%,45%)]',
    alertText: 'text-[hsl(0,70%,50%)]',
    logoBox: 'flex justify-center',
    logoImage: 'h-10 w-10 rounded-xl',
    socialButtonsBlockButton: 'border border-[hsl(40,20%,85%)] hover:bg-[hsl(40,25%,92%)]',
    formButtonPrimary:
      'bg-[hsl(15,60%,50%)] hover:bg-[hsl(15,60%,44%)] text-white font-medium',
    formFieldInput: 'bg-white border border-[hsl(40,20%,85%)] text-[hsl(240,20%,15%)]',
    footerAction: 'text-center',
    dividerLine: 'bg-[hsl(40,20%,85%)]',
    alert: 'bg-[hsl(0,70%,97%)] border border-[hsl(0,70%,85%)]',
    otpCodeFieldInput: 'bg-white border border-[hsl(40,20%,85%)] text-[hsl(240,20%,15%)]',
    formFieldRow: 'mb-4',
    main: 'gap-4',
  },
};

export const clerkLocalization = {
  signIn: {
    start: {
      title: 'Welcome back',
      subtitle: 'Sign in to comment on Mychromamind articles',
    },
  },
  signUp: {
    start: {
      title: 'Join the conversation',
      subtitle: 'Create an account to comment on Mychromamind articles',
    },
  },
};
